/* eslint-disable import/no-unresolved */
import i18next from 'i18next'
import resources from 'front-hub-locales'
import FronthubError from '../../../core/helpers/FronthubError'
import isFunction from '../../../core/helpers/isFunction'

/**
 * Build an i18next instance.
 * @param {Object} options Optional settings
 * @param {Object} options.configuration FrontHub configuration
 * @param {Object} options.configuration.intl Internalization properties
 * @param {function} options.intlFormatting Responsible to interpolate the intl formatting
 * @param {Object[]} options.plugins Array containing all plugins to be used in i18n instance
 * @returns The i18next instance
 */
const i18nFactory = ({ configuration, intlFormatting, plugins = [] }) => {
  const name = configuration.name || MICROFRONTEND_NAME
  const { intl, context } = configuration
  const i18n = i18next.createInstance()
  let handleFormatting

  if (typeof intlFormatting !== 'undefined') {
    if (!isFunction(intlFormatting)) {
      throw new FronthubError('the addon `intlFormatting` should be a function')
    }

    handleFormatting = intlFormatting(intl, context)

    if (!isFunction(handleFormatting)) {
      throw new FronthubError(
        'the addon `intlFormatting` should return a function',
      )
    }
  }

  plugins.forEach(i18n.use.bind(i18n))

  i18n.init({
    lng: intl.language,
    fallbackLng: intl.fallbackLng,
    debug: intl.debug,
    interpolation: {
      alwaysFormat: intl.interpolation?.alwaysFormat,
      formatSeparator: intl.interpolation?.formatSeparator,
      format: handleFormatting,
    },
    resources: Object.keys(resources).reduce(
      (acc, lgn) => ({
        ...acc,
        [lgn]: {
          [name]: resources[lgn],
        },
      }),
      {},
    ),
    ns: [name],
    defaultNS: name,
  })
  return i18n
}

export default i18nFactory
